import { Injectable, WritableSignal, signal } from '@angular/core';
import {
  INotification,
  NotificationSystemService,
} from 'src/app/common-components/services/common-notification-system.service';
import {
  Certification,
  ProviderDirectoryFunctionService,
} from 'src/app/services/providerdirectoryapi/providerdirectoryfunctionapi.services';

@Injectable({
  providedIn: 'root',
})
export class CertificatesService {
  private _entity: WritableSignal<Certification[]> = signal<Certification[]>([]);
  private _load: WritableSignal<boolean> = signal<boolean>(false);

  constructor(
    private searchService: ProviderDirectoryFunctionService,
    private notificationSystemService: NotificationSystemService
  ) {}

  async search() {
    this._load.set(true);
    this.searchService.getAllCertifications().subscribe({
      next: res => {
        if (res) {
          this._entity.set(res.data);
        }
        this._load.set(false);
      },
      error: error => {
        this._load.set(false);
        if (error.message) {
          const notification: INotification = { type: 'error', content: error.message };
          this.notificationSystemService.setNotification(notification);
        }
      },
    });
  }

  public updateData(data: Certification[]): void {
    this._entity.set(data);
  }

  public fetchData() {
    if (this._entity().length === 0) {
      void this.search();
    }
  }

  getCertificatesSignal(): WritableSignal<Certification[]> {
    return this._entity;
  }

  public getLoad(): WritableSignal<boolean> {
    return this._load;
  }

  public clear(): void {
    this._entity.set(null);
  }

  public clearEntity(): void {
    this._entity.set(null);
  }

  public clearLoad(): void {
    this._load.set(null);
  }
}
